module.exports = __webpack_public_path__ + "fonts/VetoSansCond-BoldItalic_1.e62482e9.ttf";